import { FaTwitter, FaInstagram, FaTiktok } from "react-icons/fa";
import { Link } from "react-router-dom";

const socials = [
	{ icon: FaTwitter, label: "Twitter", href: "https://twitter.com/marcelojose_dev" },
	{ icon: FaInstagram, label: "Instagram", href: "https://www.instagram.com/racketlyapp/" },
	{ icon: FaTiktok, label: "TikTok", href: "https://www.tiktok.com/@racketly?_t=8rwhD00mByj&_r=1" },
];

export default function FooterSection({ isDark }) {
	const surface = isDark ? "var(--color-night)" : "var(--color-paper)";
	const ink = isDark ? "var(--color-on-night)" : "var(--color-ink)";
	const muted = isDark ? "var(--color-on-night-muted)" : "var(--color-muted)";
	const rule = isDark ? "var(--color-night-rule)" : "var(--color-rule-2)";

	return (
		<footer style={{ background: surface }}>
			<div
				className="marquee"
				aria-hidden="true"
				style={{ borderTop: `var(--rule-slab) solid ${ink}`, borderBottom: `var(--rule-slab) solid ${ink}` }}
			>
				<div className="marquee__track" style={{ color: ink }}>
					{Array.from({ length: 8 }).map((_, i) => (
						<span key={i}>Racketly · Track Every Point ·</span>
					))}
				</div>
			</div>

			<div className="container mx-auto px-4 sm:px-6 py-12">
				<nav aria-label="Racketly resources" className="flex flex-wrap gap-6 mb-8" style={{ color: muted, fontSize: "var(--text-sm)" }}>
					<Link to="/">Racketly score tracker</Link>
					<Link to="/blog">Tennis & padel guides</Link>
					<Link to="/download">Download Racketly</Link>
					<Link to="/blog/how-to-use-racketly">How to track a match</Link>
				</nav>
				<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
					<div className="flex gap-6">
						{socials.map(({ icon: Icon, label, href }) => (
							<a
								key={label}
								href={href}
								target="_blank"
								rel="noopener noreferrer"
								className="lift flex items-center gap-2 font-display font-bold uppercase"
								style={{ fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)", color: muted }}
							>
								<Icon className="w-4 h-4" />
								{label}
							</a>
						))}
					</div>

					<div className="flex gap-6">
						<Link
							to="/privacy"
							style={{ fontSize: "var(--text-sm)", color: muted }}
						>
							Privacy Policy
						</Link>
						<Link
							to="/terms"
							style={{ fontSize: "var(--text-sm)", color: muted }}
						>
							Terms of Service
						</Link>
					</div>
				</div>

				<p
					className="mt-8 pt-6"
					style={{ borderTop: `var(--rule-hair) solid ${rule}`, fontSize: "var(--text-sm)", color: muted }}
				>
					© {new Date().getFullYear()} Racketly. All rights reserved.
				</p>
			</div>
		</footer>
	);
}
